import type { Reminder } from '@/core/domain';
import type { ReminderRepository } from '../repositories/reminder-repository';

export class UpdateReminderUseCase {
  constructor(private readonly repository: ReminderRepository) {}

  async execute(id: string, reminder: Partial<Reminder>): Promise<Reminder> {
    return this.repository.update(id, reminder);
  }
}
